module.exports = __webpack_public_path__ + "static/media/androidwatch.0ec9266a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/how-can-be-used/assets/androidwatch.svg
// module id = 82
// module chunks = 0